import { noop } from "lodash";
import { Button as ButtonComponent } from "@/react/components/shared/uikit/Button";

interface ButtonProps {
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
}

export const Button = ({
  onClick = noop,
  className,
  label,
  type = "button",
  dataTestId,
  disabled = false,
  ...otherProps
}: ButtonProps) => (
  <ButtonComponent
    variant="circle"
    className={className}
    onClick={onClick}
    type={type}
    data-testid={dataTestId}
    disabled={disabled}
    {...otherProps}
  >
    {label}
  </ButtonComponent>
);
